export enum ConversationDetailsLayout {
  Overview = 'Overview',
  Search = 'Search',
  Sidebar = 'Sidebar',
  SidebarCollapsed = 'SidebarCollapsed',
  SideConversation = 'SideConversation',
  ConversationHistory = 'ConversationHistory',
  TeamConversation = 'TeamConversation',
  ConversationTimeline = 'ConversationTimeline',
  Contact = 'Contact',
}
